import React, { PureComponent } from "react";
import { withRouter } from 'react-router-dom'
import AppLayout from "../../../components/layouts/AppLayout/index";
import { Table, DatePicker, Row, Col, Card, Select } from "antd";
import { Button } from '../../../components/button';
import Moment from 'moment';
import { CSVLink } from "react-csv";
import ReportsService from "../../../app/service/reportsService";
import { TableSearch } from "../../../hooks";
import moment from "moment";
import PlateService from "../../../app/service/plateService";

class Events extends PureComponent {

    //Contructor
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            tableData: [],
            tablePageSize: 10,
            totalRegisters: 0,
            currentPage: 1,
            endDate: Moment().add(1, 'days'),
            startDate: Moment().subtract(3, 'days'),
            plates: [],
            loading: false,
        }
        this.reportsService = new ReportsService();
        this.tableSearch = new TableSearch();
        this.servicePlate = new PlateService();
    }

    getPlates = () => {
        this.servicePlate
            .getPlates()
            .then(response => {
                let opt = [];
                response.data.data.forEach(item => {
                    opt.push({
                        value: item.plate,
                        label: item.plate
                    });
                });
                this.setState({
                    plates: opt,
                    loading: true,
                });

            })
            .catch(erros => {
                this.setState({
                    loading: false,
                });
                erros && erros.response && this.auth.verifyAuth(erros.response.status);
            })
    }
    //Filter Events by Date and Pagination
    filterEvents = (pageSize, pageIndex, startDate, endDate, plate) => {
        this.setState({
            loading: true,
        });

        this.reportsService.getEvents(pageSize, pageIndex, startDate, endDate, plate)
            .then(response => {
                if (response.data.status === 200) {
                    let options = [];
                    let tableData = [];
                    response.data.data.map((value, index) => {
                        options.push({ key: index, value: value.plate });
                        tableData.push({
                            key: index,
                            address: value.address,
                            date: value.date,
                            description: value.description,
                            event_status: value.event_status,
                            ignition: value.ignition,
                            latitude: value.latitude,
                            longitude: value.longitude,
                            mainBattery: value.mainBattery,
                            odometer: value.odometer,
                            plate: value.plate,
                            speed: value.speed
                        })
                    });
                    this.setState({
                        loading: false,
                        tableData: tableData,
                        totalRegisters: response.data.totalRegisters,
                    });
                } else {
                    this.setState({
                        loading: false,
                    });
                }
            }).catch(error => {
                console.error("Error", error);
                this.setState({
                    loading: false,
                });
            })
    }

    //Component mounted, call backend to request data
    componentDidMount() {
        this.setState({
            loading: true,
        });
    }

    //Render Function
    render() {
        //Data Table Columns
        const columns = [
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Placa</div>
                },
                align: 'center',
                dataIndex: 'plate',
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Data</div>
                },
                align: 'center',
                dataIndex: 'date',
                render: (text) => moment(text).format('HH:mm:ss DD/MM/YYYY'),
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Latitude</div>
                },
                align: 'center',
                dataIndex: 'latitude'
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Longitude</div>
                },
                align: 'center',
                dataIndex: 'longitude'
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Endereço</div>
                },
                align: 'center',
                dataIndex: 'address',
                ...this.tableSearch.getColumnSearchProps('address', "Endereço")
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Ignição</div>
                },
                align: 'center',
                dataIndex: 'ignition'
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Odômetro</div>
                },
                align: 'center',
                dataIndex: 'odometer'
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Velocidade</div>
                },
                align: 'center',
                dataIndex: 'speed'
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Bateria</div>
                },
                align: 'center',
                dataIndex: 'mainBattery'
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Descrição</div>
                },
                align: 'center',
                dataIndex: 'description',
                ...this.tableSearch.getColumnSearchProps('description', "Descrição")
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Status</div>
                },
                align: 'center',
                dataIndex: 'event_status',
                ...this.tableSearch.getColumnSearchProps('event_status', "Status"),
                sorter: (a, b) => a.event_status.length - b.event_status.length,
                sortDirections: ['descend']
            }
        ];

        //Pagination
        const paginationConfig = {
            defaultPageSize: this.state.tablePageSize,
            total: this.state.totalRegisters,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onChange: (page, pageSize) => {
                this.setState({
                    tablePageSize: pageSize,
                    currentPage: page
                });

                const startDate = typeof this.state.startDate === 'string' ? this.state.startDate : this.state.startDate.format("YYYY-MM-DD");
                const endDate = typeof this.state.endDate === 'string' ? this.state.endDate : this.state.endDate.format("YYYY-MM-DD");

                this.filterEvents(
                    pageSize, page, startDate, endDate
                );
            },
        }

        const paginationTable = this.state.totalRegisters === 0 ? false : paginationConfig;

        if (!this.state.loading) {
            this.getPlates();
        }

        return (
            <>
                <AppLayout>
                    <Card title="Eventos" style={{ height: '100%' }} bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }}>
                        <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                            <Col xs={24} sm={24} md={12} lg={12} xl={8} style={{ display: 'flex' }}>
                                <DatePicker
                                    format={{
                                        format: 'YYYY-MM-DD 00:00:00',
                                        type: 'mask',
                                    }}
                                    placeholder='Data Inicial'
                                    onChange={(date, dateString) => {
                                        this.setState({
                                            startDate: dateString,
                                        });
                                        this.filterEvents(
                                            this.state.tablePageSize,
                                            this.state.currentPage,
                                            dateString,
                                            this.state.endDate,
                                            this.state.searchText

                                        );
                                    }}
                                    style={{ width: '50%' }}
                                />
                                <DatePicker
                                    format={{
                                        format: 'YYYY-MM-DD 23:59:59',
                                        type: 'mask',
                                    }}
                                    placeholder='Data Final'
                                    onChange={(date, dateString) => {
                                        this.setState({
                                            endDate: dateString,
                                        });
                                        this.filterEvents(
                                            this.state.tablePageSize,
                                            this.state.currentPage,
                                            this.state.startDate,
                                            dateString,
                                            this.state.searchText

                                        );

                                    }}
                                    style={{ width: '50%', marginLeft: '5%' }}
                                />
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                    }
                                    onChange={e => {
                                        this.setState({
                                            searchText: e,
                                        });
                                        this.filterEvents(
                                            this.state.tablePageSize,
                                            this.state.currentPage,
                                            this.state.startDate,
                                            this.state.endDate,
                                            e

                                        );
                                    }}
                                    allowClear
                                    placeholder="Pesquisar por placa"
                                    options={this.state.plates ? this.state.plates : null}
                                    style={{ width: '60%' }}
                                />
                            </Col>
                            <Col span={4}>
                                <span className="d-flex justify-content-end">
                                    <Button
                                        className='successButton'
                                        type='primary'
                                        shape="round"
                                        style={{ width: '150px' }}
                                    >
                                        <CSVLink
                                            data={this.state.tableData}
                                            separator={";"}
                                            filename={"events.csv"}
                                        >
                                            Download CSV
                                        </CSVLink>
                                    </Button>
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <div style={{ marginTop: "30px" }}>
                                    <Table
                                        style={{ height: '100%' }}
                                        scroll={{ x: "max-content" }}
                                        loading={!this.state.loading}
                                        columns={columns}
                                        size='small'
                                        dataSource={this.state.tableData}
                                        pagination={paginationTable}
                                        rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </AppLayout>
            </>
        );
    }
}

export default withRouter(Events);